import {MediaTypeEnum} from '@shared/enums/media-type.enum';
import {ViewType} from '@shared/enums/view-type.enum';
import {IMediaItem} from '@interfaces/media';
import {OrderType} from '../../types/order.type';
import {IFolderPath} from '@interfaces/folder';
import {MediaSortType} from '../../types/media.type';

export class FetchMedia {
    static readonly type = '[Media] Fetch media';
}

export class SetProofOnly {
    static readonly type = '[Media] Set proof only filter';

    constructor(public enabled: boolean) {}
}

export class UpdateMediaProofFlags {
    static readonly type = '[Media] Update proof flags';

    constructor(public ids: number[], public proofEnabled: boolean) {}
}

export class CleanStoredMedia {
    static readonly type = '[Devices] Clean stored media';
}

export class SetSelectedMediaType {
    static readonly type = '[Media] Toggle media type';

    constructor(public type: MediaTypeEnum | '') {
    }
}

export class ChangeMediaPerPage {
    static readonly type = '[Media] Change media per page';

    constructor(public mediaPerPage: number) {
    }
}

export class SetMediaPerPage {
    static readonly type = '[Media] Set media per page';

    constructor(public mediaPerPage: number) {
    }
}

export class SearchMedia {
    static readonly type = '[Media] Change search media param';

    constructor(public searchParam: string) {
    }
}

export class ChangeCurrentMediaPage {
    static readonly type = '[Media] Change current page';

    constructor(public currentPage: number) {
    }
}

export class CleanSearchMediaParam {
    static readonly type = '[Media] Clean search media param';
}

export class ToggleMediaView {
    static readonly type = '[Media] Toggle View type';

    constructor(public type: ViewType) {
    }
}

export class DeleteMedia {
    static readonly type = '[Media] Delete media from directory';

    constructor(public mediaIds: number[], public directoryId: number,
                public sourceFolders?: {folderId: number; mediaIds: number[]}[]) {
    }
}

export class DeleteFolders {
    static readonly type = '[Media] Delete medias folders';

    constructor(public ids: number[]) {
    }
}

export class EditMedia {
    static readonly type = '[Media] Edit media';

    constructor(public media: IMediaItem) {
    }
}

export class SortMediasContent {
    static readonly type = '[Media] sort medias content';

    constructor(public order: OrderType, public sort: MediaSortType) {
    }
}

export class SetMediaDefaultPerPage {
    static readonly type = '[Media] Set default value for medias';

    constructor(public perPage?: number) {
    }
}

export class ChangeSearchMediaParam {
    static readonly type = '[Media] Change search param';

    constructor(public searchParam: string) {
    }
}

export class CleanMedias {
    static readonly type = '[Media] Clean medias';
}

export class SetTargetFolderPath {
    static readonly type = '[Media] Set current folder path';

    constructor(public path: IFolderPath) {
    }
}

export class ResetMediaState {
    static readonly type = '[Media] Reset media state';
}

export class UpdateMediaFromApi {
    static readonly type = '[Media] Update media from API';

    constructor(public media: IMediaItem) {
    }
}
